const AdminTable = ({headers, data}) => {
    return (<div className="card rounded-lg table-responsive">
            <table className='table table-hover font-small mb-0'>
                <thead className={""}>
                <tr>
                    {headers.map(header => (<th key={header.id} className={header.className}>{header.label}</th>))}
                </tr>
                </thead>
                <tbody>
                {data.map((row, index) => {
                    return (<tr key={index} >
                            {headers.map(header => (<td key={header.id} onClick={()=> header.onClick(row) || null}>{header.render(row)}</td>))}
                        </tr>)
                })}
                </tbody>
            </table>

        </div>)
}

export default AdminTable